import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ModalTypes, QuestionType} from '../../../constants';
import {Question, ShoppingCartItem} from '../../../models/underwriter.model';
import {FlowPlayerService} from '../../../services/flow-player.service';
import {GlobalQuestionService} from '../../../services/global-question.service';
import {QuestionFlowSessionQuery} from '../../state/question-flow-session.query';
import {QuestionGroups} from '../../../models/question-groups';
import {PolicyEditQuestion} from '../../../models/policy.model';

declare var $: any;

@Component({
    selector: 'app-event-details',
    templateUrl: './event-details.component.html',
    styleUrls: ['./event-details.component.scss'],
    standalone: false
})
export class EventDetailsComponent implements OnInit, OnChanges {

  @Input() cart_item: ShoppingCartItem;
  @Input() showItemDetails = false;
  @Input() display_type: ModalTypes;
  @Output() removeItem = new EventEmitter<{ item: ShoppingCartItem }>();

  question: Question;
  claim_details: any = {};
  questions: Question[];
  isSavingData = false;
  session_details: any;
  childrenQuestions: Question[] = [];
  loading = false;
  QuestionType = QuestionType;
  questionGroups: QuestionGroups[] = [];
  responseQuestions: Question[] = [];

  constructor(
    private globalQuestionService: GlobalQuestionService,
    private sessionQuery: QuestionFlowSessionQuery,
    private flowPlayer: FlowPlayerService) {
  }

  ngOnInit(): void {
    this.session_details = this.sessionQuery.getValue();
    /*this.getFlowQuestions(this.cart_item?.flow_id, this.cart_item?.item_id, this.cart_item?.class_id);*/
    this.populateClaimDetails();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.showItemDetails?.currentValue !== changes?.showItemDetails?.previousValue) {
      this.showItemDetails = changes?.showItemDetails?.currentValue;
    }
    if (changes?.cart_item?.currentValue !== changes?.cart_item?.previousValue) {
      this.cart_item = changes?.cart_item?.currentValue;
    }
    if (this.cart_item) {
      this.getQuestions();
    }
  }

  populateClaimDetails(): void {
    this.globalQuestionService.getClaim()
      .subscribe((c: any[]) => {
        if (!c?.length) {
          return;
        }
        this.claim_details.claim_id = c[0]?.claim_id;
        this.claim_details.claim_name = c[0]?.claim_name;
        this.claim_details.claim_status = c[0]?.claim_status;
        this.claim_details.policy_id = c[0]?.policy_id;
        this.claim_details.version_id = c[0]?.version_id;
      });
  }

  getItemChildrenQuestions(question: Question): Question[] {
    const childQuestions = this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
    return this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }

  questionResponse(event: Question): void {
    if (event?.dependant_flow_id) {
      this.question = event;
      $('#modal-additional').modal('show');
    } else {
      const questionIndex = this.questions?.findIndex(question => question.cent_aq_question_id === event.cent_aq_question_id);
      if (questionIndex > -1) {
        if (!this.isSavingData) {
          this.isSavingData = true;
          this.questions[questionIndex] = event;
          this.globalQuestionService.saveIndividualAnswer(this.questions[questionIndex], this.questions[questionIndex]?.item_id)
            .subscribe(() => {
              this.isSavingData = false;
              this.globalQuestionService.setSummaryDataObservable(true);
            });
        }
      }
    }
  }

  getQuestions(): void {
    this.globalQuestionService.spinner(true);
    this.questions = [];
    this.childrenQuestions = [];
    this.globalQuestionService.getResponses()
      .subscribe((questions: Question[]) => {
        if (!questions?.length) {
          return;
        }

        if (questions?.length) {
          this.responseQuestions = questions;
          this.questions = [];
          this.childrenQuestions = [];

          for (const q of questions) {
            if (this.display_type === ModalTypes.police_report_details
              ? q?.item_id?.toString() === this.cart_item?.item_id?.toString() && q?.product_class_id?.toString() === this.cart_item?.class_id?.toString() && q?.flow_id?.toString() === this.cart_item?.flow_id?.toString()
              : q?.item_id?.toString() === this.cart_item?.item_id?.toString() && q?.product_class_id?.toString() === this.cart_item?.class_id?.toString()) {
              if (q?.parent_control) {
                this.childrenQuestions.push(q);
                const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
                if (parentQuestion) {
                  if (!this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id && x?.item_id === q?.item_id)) {
                    this.questions.push(parentQuestion);
                  }
                } else {
                  this.questions.push(q);
                }
              } else {
                if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id && x?.item_id === q?.item_id)) {
                  this.questions.push(q);
                }
              }
            }
          }
          this.getQuestionGrouping();
        }
        this.globalQuestionService.spinner(false);
        this.loading = false;
      });
  }

  getQuestionGrouping(): void {
    this.questionGroups = [];
    if (this.questions?.length) {
      if (this.display_type === ModalTypes.item_details) {
        this.globalQuestionService.getQuestionGrouping()
          .subscribe((groups: PolicyEditQuestion[]) => {
            console.log(groups)
            if (groups?.length) {
              for (const g of groups) {
                if (!this.questionGroups?.some(x => x?.group_name === g?.group_name)) {
                  const questionGroup = new QuestionGroups();
                  const question = this.questions.find(x => x?.cent_aq_question_id === g?.cent_aq_question_id && x?.item_id === g?.item_id);
                  questionGroup.group_type = g?.group_type;
                  questionGroup.group_name = g?.group_name;
                  questionGroup.class_id = g?.class_id;
                  questionGroup.questions = [];
                  if (question) {
                    questionGroup.questions.push(question);
                  }
                  this.questionGroups.push(questionGroup);
                } else {
                  const question = this.questions.find(x => x?.cent_aq_question_id === g?.cent_aq_question_id);
                  if (question) {
                    const index = this.questionGroups.findIndex(x => x?.group_name === g?.group_name);

                    if (index > -1 && !this.questionGroups[index]?.questions?.some(x => x?.cent_aq_question_id === question?.cent_aq_question_id && x?.item_id === question?.item_id)) {
                      this.questionGroups[index].questions.push(question);
                    }
                  }
                }
              }
            }
            
          });
      }
    }
  }

  getChildQuestions(question_id: number, item_id: string): Question[] {
    if (this.childrenQuestions?.length) {
      return this.childrenQuestions?.filter(x => x?.parent_control === question_id && x?.item_id === item_id);
    } else {
      return [];
    }
  }
}
